import { useTranslation } from '../../i18n';

const ArrowSvg = ({ color = '#534AB7' }: { color?: string }) => (
  <svg className="chip-arr" width="22" height="12" viewBox="0 0 22 12" fill="none">
    <line x1="0" y1="6" x2="15" y2="6" stroke={color} strokeWidth="1.8" />
    <path d="M13 2L19 6L13 10" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

export default function LayerA() {
  const { dict } = useTranslation();
  return (
    <div className="layer layer-a">
      <div className="layer-wm-wrap">
        <img
          className="layer-wm"
          src="https://ntq.com.vn/wp-content/themes/ntq_branding/assets/images/NTQ-logo.png"
          alt=""
          aria-hidden="true"
          onError={e => { (e.currentTarget as HTMLImageElement).style.display = 'none'; }}
        />
      </div>

      <div className="layer-header">
        <span className="layer-badge badge-a">{dict.la_badge}</span>
        <div>
          <div className="layer-title">NxKMS &mdash; Knowledge Management System</div>
          <div className="layer-sub">{dict.la_sub}</div>
        </div>
      </div>

      <div className="layer-body">
        <div className="sec-label">{dict.la_src_label}</div>
        <div className="src-row">
          <div className="src-card src-a-border">
            <svg className="src-icon" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <rect x="3" y="2" width="16" height="18" rx="2.5" stroke="#534AB7" strokeWidth="1.5" fill="none" />
              <line x1="6.5" y1="7.5" x2="15.5" y2="7.5" stroke="#534AB7" strokeWidth="1.3" />
              <line x1="6.5" y1="11" x2="15.5" y2="11" stroke="#534AB7" strokeWidth="1.3" />
              <line x1="6.5" y1="14.5" x2="12" y2="14.5" stroke="#534AB7" strokeWidth="1.3" />
            </svg>
            <span className="src-title">{dict.la_s1_t}</span>
            <span className="src-desc">{dict.la_s1_d}</span>
          </div>

          <div className="src-card src-b-border">
            <img
              className="src-icon src-logo-img"
              src="https://upload.wikimedia.org/wikipedia/commons/1/12/Google_Drive_icon_%282020%29.svg"
              alt="Google Drive"
              onError={e => { (e.currentTarget as HTMLImageElement).src = 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v11/icons/googledrive.svg'; }}
            />
            <span className="src-title">{dict.la_s2_t}</span>
            <span className="src-desc">{dict.la_s2_d}</span>
          </div>

          <div className="src-card src-c-border">
            <div className="logo-pair">
              <img
                className="src-logo-img-sm"
                src="https://upload.wikimedia.org/wikipedia/commons/4/45/Notion_app_logo.png"
                alt="Notion"
                onError={e => { (e.currentTarget as HTMLImageElement).src = 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v11/icons/notion.svg'; }}
              />
              <span className="logo-sep">+</span>
              <img
                className="src-logo-img-sm"
                src="https://upload.wikimedia.org/wikipedia/commons/d/d5/Slack_icon_2019.svg"
                alt="Slack"
                onError={e => { (e.currentTarget as HTMLImageElement).src = 'https://cdn.jsdelivr.net/gh/simple-icons/simple-icons@v11/icons/slack.svg'; }}
              />
            </div>
            <span className="src-title">{dict.la_s3_t}</span>
            <span className="src-desc">{dict.la_s3_d}</span>
          </div>

          <div className="src-card src-a-border">
            <svg className="src-icon" width="22" height="22" viewBox="0 0 22 22" fill="none">
              <circle cx="11" cy="11" r="8.5" stroke="#534AB7" strokeWidth="1.4" fill="none" />
              <ellipse cx="11" cy="11" rx="3.5" ry="8.5" stroke="#534AB7" strokeWidth="1.2" fill="none" />
              <line x1="2.5" y1="11" x2="19.5" y2="11" stroke="#534AB7" strokeWidth="1.2" />
            </svg>
            <span className="src-title">{dict.la_s4_t}</span>
            <span className="src-desc">{dict.la_s4_d}</span>
          </div>
        </div>

        <div className="sec-label mt16">{dict.la_flow_label}</div>
        <div className="flow-row">
          <span className="flow-chip fca">{dict.la_f1}</span>
          <ArrowSvg />
          <span className="flow-chip fca">{dict.la_f2}</span>
          <ArrowSvg />
          <span className="flow-chip fca">{dict.la_f3}</span>
          <ArrowSvg />
          <span className="flow-chip fca">{dict.la_f4}</span>
        </div>
        <div className="flow-row mt6">
          <span className="flow-chip fca">{dict.la_f5}</span>
          <ArrowSvg />
          <span className="flow-chip fca">{dict.la_f6}</span>
          <ArrowSvg />
          <span className="flow-chip fca">{dict.la_f7}</span>
        </div>

        <div className="sub2 mt10">
          <div className="sub-card">
            <div className="sub-card-t"><span className="dot da" /><span>{dict.la_m1_t}</span></div>
            <div className="sub-card-d">{dict.la_m1_d}</div>
          </div>
          <div className="sub-card">
            <div className="sub-card-t"><span className="dot da" /><span>{dict.la_m2_t}</span></div>
            <div className="sub-card-d">{dict.la_m2_d}</div>
          </div>
        </div>

        {/* User Flow (admin + user) */}
        <div className="sec-label mt16">{dict.la_uflow_label}</div>
        <div className="uflow-split">
          <div className="uflow-col uflow-col--admin">
            <div className="uflow-col-t">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <circle cx="7" cy="4.5" r="2.2" stroke="currentColor" strokeWidth="1.3" fill="none"/>
                <path d="M2.5 12c.3-2.2 2.2-3.8 4.5-3.8s4.2 1.6 4.5 3.8" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none"/>
              </svg>
              <span>{dict.la_uflow_admin_t}</span>
            </div>
            <ol className="uflow-steps">
              {dict.la_uflow_admin_steps.map((s, i) => (
                <li key={i}><span className="uflow-n">{i + 1}</span><span>{s}</span></li>
              ))}
            </ol>
          </div>
          <div className="uflow-col uflow-col--user">
            <div className="uflow-col-t">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M3 11l.7-2.3A3.5 3.5 0 0 1 7 6.5h0a3.5 3.5 0 0 1 3.3 2.2L11 11" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" fill="none"/>
                <circle cx="7" cy="3.5" r="1.8" stroke="currentColor" strokeWidth="1.3" fill="none"/>
              </svg>
              <span>{dict.la_uflow_user_t}</span>
            </div>
            <ol className="uflow-steps">
              {dict.la_uflow_user_steps.map((s, i) => (
                <li key={i}><span className="uflow-n">{i + 1}</span><span>{s}</span></li>
              ))}
            </ol>
          </div>
        </div>

        {/* UI Mockup — ChatGPT-like interface */}
        <div className="sec-label mt16">{dict.la_ui_demo_label}</div>
        <div className="kms-mock">
          <div className="kms-mock-side">
            <div className="kms-mock-side-t">{dict.la_ui_sidebar_t}</div>
            {dict.la_ui_bots.map((bot, i) => (
              <div key={i} className={`kms-mock-bot${bot.active ? ' is-active' : ''}`}>
                <div className="kms-mock-bot-av">{bot.name.charAt(0)}</div>
                <div className="kms-mock-bot-txt">
                  <div className="kms-mock-bot-n">{bot.name}</div>
                  <div className="kms-mock-bot-d">{bot.desc}</div>
                </div>
              </div>
            ))}
          </div>
          <div className="kms-mock-chat">
            <div className="kms-mock-msgs">
              <div className="kms-mock-msg kms-mock-msg--user">
                <div className="kms-mock-bubble">{dict.la_ui_user_msg}</div>
              </div>
              <div className="kms-mock-msg kms-mock-msg--bot">
                <div className="kms-mock-av">AI</div>
                <div>
                  <div className="kms-mock-bubble">{dict.la_ui_bot_msg}</div>
                  <div className="kms-mock-src">
                    <span className="kms-mock-src-t">📎 {dict.la_ui_sources_t}:</span>
                    {dict.la_ui_sources.map((s, i) => (
                      <span key={i} className="kms-mock-src-tag">{s}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="kms-mock-input">
              <span className="kms-mock-input-ph">{dict.la_ui_input_ph}</span>
              <button className="kms-mock-send" aria-label="send">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                  <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
